import { Button, IconButton, Tooltip } from "@mui/material";
import { DeleteIconButton } from "../../../assets/common-svg/CommonSvg";
import FormikControl from "../../../bmr/components/common/FormikControl";
import { FieldArray, FormikProvider } from "formik";

const FormikArrayPreScreen = ({ props, formik, disabledAll, handleQuestionClick, queriesFields ,buttonPermission}) => {

     const parseFieldValue = (value) => {
        if (Array.isArray(value)) return value;
        if (typeof value === 'string') {
            try {
                return JSON.parse(value);
            } catch {
                return [];
            }
        }
        return [];
    };

    return <FormikProvider value={formik}>
        <FieldArray name={props.name}>
            {({ push, remove }) => (
                <div
                    className={!props.col ? `flex flex-col md:flex-row gap-4 items-start md:items-center` : `border rounded-lg shadow-sm bg-white m-2`}>
                    { parseFieldValue(formik.values[props.name])?.map((_, index) => (
                        <div
                            key={index}
                            className={props.col ? `p-4 flex flex-col md:flex-row gap-4 items-start md:items-center` : `flex-1 grid grid-cols-1 md:grid-cols-1 gap-4 w-full`}
                        >
                            <div
                                className={props.col && `flex-1 grid grid-cols-1 md:grid-cols-${props.col} gap-4 w-full`}
                            >
                                {props.children(index).map((subFieldProps, subFieldPropsIndex) => {
                                    const questionInfo = queriesFields?.find(op => op.fields === subFieldProps.name);

                                    return (
                                        <div key={subFieldPropsIndex} className="w-full relative">
                                            <FormikControl
                                                formik={formik}
                                                {...subFieldProps}
                                                disabled={questionInfo?.resolve == 0 ? false : subFieldProps.disabled}
                                            />
                                            {!subFieldProps.noQuery && disabledAll && <i
                                                onClick={(e) => handleQuestionClick(e, subFieldProps, questionInfo)}
                                                style={questionInfo?.resolve == 0 ? { color: "red" } : {}}
                                                className="fas fa-question-circle circle-icon cursor-pointer z-50 absolute top-[2.2rem] right-6"
                                                aria-hidden="true"
                                            />}
                                        </div>
                                    );
                                })}

                            </div>
                            {props.multipleField &&
                                < div className={(disabledAll || formik.values[props.name].length == 1) ? " self-end md:self-center mt-3 disable-add-visit-btn" : " self-end md:self-center mt-3"} >
                                    <Tooltip title="Delete" >
                                        <span>
                                            <IconButton
                                                onClick={() => { (disabledAll || formik.values[props.name].length == 1) ? "" : remove(index) }}
                                            >
                                                <DeleteIconButton
                                                    bgColor={"#FA5151"}
                                                />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </div>
                            }
                        </div>
                    ))}
                    {props.multipleField && !disabledAll && buttonPermission &&
                        < div className="text-end m-2">
                            <Button
                                type="button"
                                disabled={disabledAll}
                                // variant="contained"
                                onClick={() => push(props.initialChildrenData || {})}
                                className="mt-4"
                                fullWidth
                            >
                                Add
                            </Button>
                        </div>
                    }
                </div>
            )}
        </FieldArray>
    </FormikProvider >
}

export default FormikArrayPreScreen;